<div class="logsize ">
  <div>
    <mat-carousel class="plan-guide-c" timings="2000ms ease-in" [autoplay]="false" color="accent" [interval]="15000"
      maxWidth="auto" [loop]="true" [hideArrows]="false" [hideIndicators]="false" [useKeyboard]="true"
      [useMouseWheel]="false">
      <mat-carousel-slide *ngFor="let item of this.myPlans; let i = index" [hideOverlay]="true">
        <div class="plans-box-container m-top-p">
          <div *ngFor="let plan of this.myPlans[i]; let j = index" (click)="this.selectPlan(plan.productId)"
            class="plan-box"
            [ngClass]="{'selectedON': this.idPlan==plan.productId,'selectedOFF': this.idPlan!=plan.productId}">
            <div [ngClass]="{ hidden: plan.bitPromotion==false }">
              <div class="container-headband">
                <div class="container-headband-1">
                  <img width="100%" height="100%" class="renew-icon" src="/assets/images/offers/tag_oferta.png">
                </div>
              </div>
              <div class="ofert-title roboto-m">
                <div>
                  <img class="renew-icon oferr-icon" src="/assets/images/offers/tag_white.png">
                </div>
                <div *ngIf="plan.offer!=null" class="txt-left info-oferr">
                  <a class="servicetermslink cursor" (click)="this.showterms(plan.offer)">
                    {{(this.global.textShortener((plan.offer.chvOfferDetails),'',22,'...'))}}
                  </a>
                </div>
              </div>
            </div>
            <div class="plan-info-box">
              <div class="plan-name">
                {{plan.productName}}
              </div>
              <div class="plan-price-container">
                <div class="plan-icon">
                  <img class="plan-icon" src="./assets/images/icon_planesIPTV.png">
                </div>
                <div class="plan-price">
                  <div class="plan-price-title">
                    Precio Mensual
                  </div>
                  <div class="plan-amount">
                    {{plan.regular_price | currency}}
                  </div>
                </div>
              </div>
              <hr>
              <div class="plan-type-description">
                <div [innerHTML]="plan.shortDescription" class="plan-type "> </div>
              </div>
              <hr>
              <div class="plan-type-container">
                <div class="plan-type-name roboto-m">
                  Plan de <span class="ClaroTv">Claro</span><span class="tvmas">tv+</span>
                </div>
                <div class="plan-type">
                  {{plan.type}}
                </div>
              </div>
              <hr>
              <div class="plan-channels">
                <div class="plan-channels-header">
                  <div class="plan-channels-title roboto-m">
                    Canales
                  </div>
                  <div class="plan-channels-info">
                  </div>
                </div>
                <div class="plan-channels-list">
                  <div class="channels-list" *ngFor="let channel of this.jsonChannels(plan.productId) let k = index">
                    <div>
                      <img class="channel-img" src="{{(channel.url).replace('img','images')}}">
                    </div>
                  </div>
                </div>
                <div class="see-channel-guide">
                  <a (click)="goToChannelList(plan.productId,plan.productName)" class="linkdefs">Ver Guía de
                    Canales&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                </div>
              </div>
              <hr>
              <div class="plan-see-btn">
                <div [ngClass]="{ red: this.idPlanAux==plan.productId, disabled: this.checkIptv==false}"
                 (click)="this.goToBuy(plan.productId,plan.check,plan.regular_price)" class="button-white">
                  Selecionar plan 
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-carousel-slide>
    </mat-carousel>
  </div>
  <hr>
  <div class="basicrow m-top-i graybg mobile-b">
    <div class="container container-benefits">
      <div class="basicrow m-top m-bott">
        <div class="basicrow f-big roboto-l2 f-black">
          Disfruta de los beneficios de
          <label class="clarotv3">Claro</label>
          <label class="tvmas3">tv+</label>
        </div>
        <div class="basicrow m-top-i">
          <div class="row refdef">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class="basicrow text-center">
                <img width="100%" class="ref-icons" src="../assets/images/icon_premium.png">
              </div>
              <div class="basicrow f-black roboto-r f-reg text-center m-top">
                <div class="basicrow f-bmed roboto-b">
                  Canales Premium
                </div>
                <div class="text-benefits">
                  Conoce los Canales Premium de Clarotv+.
                </div>
                <div class="basicrow m-top">
                  <a class="linkdefs">Ver Detalle&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 hrefmtop">
              <div class="basicrow text-center">
                <img width="100%" class="ref-icons" src="../assets/images/icon_guiacanales.png">
              </div>
              <div class="basicrow f-black roboto-r f-reg text-center m-top">
                <div class="basicrow f-bmed roboto-b">
                  Guía de Programación
                </div>
                <div class="text-benefits">
                  Consulta nuestra guía de canales para Clarotv+.
                </div>
                <div class="basicrow m-top">
                  <a ui-sref="netflix_questions" class="linkdefs">Ver
                    Detalle&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr>
  <div class="basicrow">
    <div>
      <div class="row m-top-i">
        <div class="w-100">
          <div class="basicrow">
            <div class="row center-2">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="basicrow f-big roboto-l">
                  Guía de Canales
                </div>
              </div>
              <div class="text-end">
                <a (click)="goToChannelList()" class="linkdefs">Ver Guía de Canales&nbsp;&nbsp;<i
                    class="fa fa-angle-right" aria-hidden="true"></i></a>
              </div>
            </div>
            <div class="carousel-1">
              <mat-carousel class="plan-guide-c1" timings="2000ms ease-in" [autoplay]="false" color="accent"
                [interval]="15000" maxWidth="auto" [loop]="true" [hideArrows]="false" [hideIndicators]="true"
                [useKeyboard]="true" [useMouseWheel]="false">
                <mat-carousel-slide *ngFor="let list of this.channelGuideList; let i = index" [hideOverlay]="true">
                  <div class="channel-grid">
                    <div *ngFor="let channel of this.channelGuideList[i]">
                      <img class="channel-img-2" src="{{(channel.url).replace('img','images')}}">
                    </div>
                  </div>
                </mat-carousel-slide>
              </mat-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
